/* global window document pymChild */
import { Child } from 'pym.js';

import './styles/graphic.scss';

import data from './data/paperdoc.json';

// instantiate pym object
window.pymChild = new Child();

let mapParams;
const graphic_slug = '20220607-text-message-display';

// check for URL params
function checkParams() {
  // use the parent URL if we're using the "parent.html" preview page
  // otherwise use the straight url
  let url;
  if ((pymChild.parentUrl) && (pymChild.parentUrl.indexOf('/parent.html') !== -1)) {
    url = pymChild.parentUrl;
  } else {
    url = window.location.href;
  }

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  mapParams = getParams(url);
}

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  checkParams();

  const set = data[mapParams.set];

  console.log('Data:', data);
  console.log('Set:', set);

  const set_box = container.append('div')
    .attr('class', 'v-set-box');

  set_box.append('div')
    .attr('class', 'v-set-date')
    .html(set.date);

  set.messages.forEach((message, i) => {
    const people = message.fromto.split(' to ');
    let message_align;
    if (people[0].trim().toLowerCase() == set.phoneof.trim().toLowerCase()) {
      message_align = 'right';
    } else {
      message_align = 'left';
    }

    const message_box = set_box.append('div')
      .attr('class', `v-message v-align-${message_align}`);


    message_box.append('div')
      .attr('class', 'v-message-from')
      .html(`${people[0]}${(message.time) ? `<span class='v-message-time'>${message.time}</span>` : ''}`);

    message_box.append('div')
      .attr('class', `v-message-text v-align-${message_align}`)
      .html(message.text);

    if (set.include_to == true || set.include_to == 'yes') {
      message_box.append('div')
        .attr('class', 'v-message-to')
        .html(`to ${people[1]}`);
    }
  });


  // webtag for the console
  console.log('- - - - - - - - - -');
  let new_params;
  if (mapParams.set) {
    new_params = `?set=${mapParams.set}`;
    console.log(`SLUG: text-message-set-${mapParams.set}`);
  }
  const time_hash = Date.now().toString(36);

  console.log('DLE link:');
  console.log(`https://ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}`);
  console.log('Web tag:');
  console.log(`<div id="responsive-embed-${graphic_slug}-${time_hash}"></div>
  <script>
  if(!window.pym){(function(b,c){var d=document.createElement("script");d.type="text/javascript",d.readyState?d.onreadystatechange=function(){("loaded"===d.readyState||"complete"===d.readyState)&&(d.onreadystatechange=null,c())}:d.onload=function(){c()},d.src=b,document.getElementsByTagName("head")[0].appendChild(d)})("//cdn.cnn.com/cnn/.e/interactive/js/lib/vendor/pym/pym.v1.min.js",function(){new pym.Parent("responsive-embed-${graphic_slug}-${time_hash}","//ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}",{title:"CNN Graphic"})})}else var responsiveEmbed=new pym.Parent("responsive-embed-${graphic_slug}-${time_hash}","//ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}",{title:"CNN Graphic"});
  </script>`);
}
